import React from "react";
import { useInstance } from "@/context/InstanceContext";

/**
 * Cinematic page hero. Uses the uploaded branding wallpaper as backdrop
 * with a heavy darkening gradient so foreground text stays readable.
 */
export default function HeroBanner({ eyebrow, title, meta, badge, right }) {
  const { branding } = useInstance();
  const bg = branding.backgroundUrl;

  return (
    <section className="hero-banner corners fade-up">
      <span className="corner-tr" />
      <span className="corner-bl" />
      <div
        className="hero-banner-bg"
        style={bg ? { backgroundImage: `url(${bg})` } : { background: "linear-gradient(135deg, #1a1610 0%, #07060a 100%)" }}
      />
      <div className="hero-banner-content">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div className="min-w-0">
            <div className="flex items-center gap-2 mb-2 flex-wrap">
              <span className="classified">CLASSIFIED</span>
              {eyebrow && (
                <span className="label-tech" style={{ color: "var(--tan-bright)" }}>
                  {eyebrow}
                </span>
              )}
              {badge}
            </div>
            <h1 className="headline-stencil">{title}</h1>
            {meta && (
              <div className="mt-3 text-xs font-mono-tech" style={{ color: "var(--text-muted)" }}>
                {meta}
              </div>
            )}
          </div>
          {right && <div className="shrink-0">{right}</div>}
        </div>
      </div>
    </section>
  );
}
